import { MISSION_IMG } from "@/data/services";
import { Globe2, Target, Users } from "lucide-react";

export const MissionSection = () => {
  return (
    <section id="about" className="relative py-28 bg-brand-dark">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <p className="text-sm tracking-[0.2em] uppercase font-semibold text-white mb-3">Our mission</p>
          <h2 className="text-3xl sm:text-4xl font-heading font-extrabold tracking-tight mb-6 text-white">
            Encouraging entrepreneurship, developing enterprises.
          </h2>
          <p className="text-gray-300 font-medium leading-relaxed mb-8">
            We provide effective utilization of labor by encouraging entrepreneurship, developing enterprises
            and talents. We connect domestic producers and social projects to international agencies for
            training and capital access — with a relentless focus on quality and client satisfaction.
          </p>
          <div className="space-y-4">
            {[
              [Target, "Effective labor & talent utilization"],
              [Globe2, "Domestic to international market linkage"],
              [Users, "Seminars, training & capital access"],
            ].map(([Icon, t]) => (
              <div key={t} className="flex items-center gap-4">
                <div className="h-10 w-10 rounded-sm bg-white/10 border border-white/30 flex items-center justify-center shrink-0">
                  <Icon size={18} className="text-orange-500" />
                </div>
                <span className="text-base font-semibold text-gray-100">{t}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="relative">
          <img src={MISSION_IMG} alt="Entrepreneurship education" className="rounded-lg border border-white/10 shadow-lg w-full object-cover h-[420px]" />
          <div className="absolute -bottom-6 -left-6 bg-brand-yellow text-brand-dark rounded-lg p-6 max-w-[200px] shadow-2xl">
            <p className="text-4xl font-heading">2</p>
            <p className="text-sm mt-1 font-medium">Continents served — Tanzania & the USA</p>
          </div>
        </div>
      </div>
    </section>
  );
};
